import App from "./App.svelte";
import { router, end } from "./util/router";

import "./styles/app.scss";

const app = new App({
  target: document.body ?? document.querySelector("body"),
});

router("/:view", end);

router("/", end);

router.start({
  dispatch: true,
  popstate: true,
  click: true,
  hashbang: false,
});
